import React, { useMemo, useState } from 'react';
import type { PropsWithChildren } from 'react';
import { defineMessages } from 'react-intl';
import { seller } from '../../mock';

import { SellerProvider } from '../SellerBody/SellerContext';
import type { ShippingQuote } from '../SellerBody/SellerContext';
import { useCssHandles } from '../../../utils/functions';

const SELLERS_CSS_HANDLES = ['sellerMasterContainer'] as const;

interface Props {
	limitShownShippingInformation: number;
	componentId?: string;
	blockClass?: string;
}

function SellerTable({ limitShownShippingInformation, children, componentId, blockClass }: PropsWithChildren<Props>) {
	const { handles }: any = useCssHandles('vtex-seller-selector-0-x', SELLERS_CSS_HANDLES, blockClass);
	const [shippingQuotes, setShippingQuotes] = useState<ShippingQuote | null>(null);

	const sellerContext = useMemo(
		() => ({
			sellerList: [seller, seller],
			shippingQuotes,
			setShippingQuotes,
			limitShownShippingInformation: limitShownShippingInformation || 3,
		}),
		[limitShownShippingInformation, , shippingQuotes],
	);

	return (
		<div data-selection={componentId} className={`${handles.sellerMasterContainer}`}>
			<SellerProvider value={sellerContext}>{children}</SellerProvider>
		</div>
	);
}

const messages = defineMessages({
	title: {
		defaultMessage: '',
		id: 'admin/editor.seller-selector.title',
	},
	shippingInformationTitle: {
		defaultMessage: '',
		id: 'admin/editor.seller-selector.limitShippingInformation-title',
	},
	shippingInformationDescription: {
		defaultMessage: '',
		id: 'admin/editor.seller-selector.limitShippingInformation-description',
	},
});

SellerTable.schema = {
	title: messages.title.id,
	type: 'object',
	properties: {
		limitShownShippingInformation: {
			title: messages.shippingInformationTitle.id,
			description: messages.shippingInformationDescription.id,
			type: 'number',
			default: 3,
		},
	},
};

export default SellerTable;
